import React from 'react';
import Box from '@components/Atoms/Box';
import { useHistory, useParams } from 'react-router-dom';
import { Divider } from '@mui/material';
import NavItem from '@components/Atoms/NavItem';
import ActionRequiredWrapper from '@contexts/ActionRequired/ActionRequiredWrapper';
import { useGetTestlets } from '../../hooks';

const navItemsData = (
  courseId: string,
  sectionId: string,
  testSessionId: string | number,
) => [
  {
    title: 'Scores',
    url: `/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/scores`,
  },
  {
    title: 'Reports',
    url: `/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/reports`,
  },
];

const NavTestletsList = ({
  testSessionId,
  setSelectedTestSessionId,
}: {
  testSessionId: number;
  setSelectedTestSessionId: (testSessionId: number) => void;
}) => {
  const { data: testlets } = useGetTestlets(testSessionId);
  const { courseId, sectionId } = useParams();
  const history = useHistory();

  const handleTestletClick = (selectedTestletId: number) => {
    setSelectedTestSessionId(testSessionId);
    history.push(
      `/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/testlet/${selectedTestletId}`,
    );
  };

  return (
    <Box
      className="isolate-action-required-wrapper"
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}
    >
      {testlets?.map((testlet) => (
        <Box
          onClick={() => {
            handleTestletClick(testlet.id);
          }}
          key={testlet.id}
        >
          <ActionRequiredWrapper checkPath={['LE', +testSessionId, +testlet.id]}>
            <NavItem
              title={testlet.name}
              disableMessage=""
              className="actionable"
              url={`/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/testlet/${testlet.id}`}
            />
          </ActionRequiredWrapper>
        </Box>
      ))}
      <Divider />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {navItemsData(courseId, sectionId, testSessionId).map((item) => (
          <NavItem key={item.title} title={item.title} url={item.url} />
        ))}
      </Box>
    </Box>
  );
};

export default NavTestletsList;
